var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './customer.forms.scss';
import { initialState, reducer, FormContext } from "../../common/context/context";
import LangSwitcher from '../../components/_common/lang/switcher';
import FormWrapper from '../../components/pages/forms/wrapper/wrapper';
import Icons from '../../icons';
import { RightAlignedComponent, SpaceBetweenContainer } from '../../styles/generalStyles';
var videoBg = 'https://d15oaqjca840o0.cloudfront.net/login.mp4';
export default function CustomerForms() {
    var _a;
    var location = useLocation();
    var formFromPathname = ((_a = location.search) === null || _a === void 0 ? void 0 : _a.split('?')[1]) || location.pathname.split('/')[1];
    var _b = React.useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var _c = useState(formFromPathname || 'login'), activeForm = _c[0], setActiveForm = _c[1];
    var _d = useState(window.innerWidth >= 768), isVideoPlayable = _d[0], setIsVideoPlayable = _d[1];
    var _e = useState(true), isVideoControlsVisible = _e[0], setVideoControlsVisible = _e[1];
    var _f = useState('fadeIn'), animationClass = _f[0], setAnimationClass = _f[1];
    var videoRef = useRef(null);
    var handleFormChange = function (formName) {
        setActiveForm(formName);
    };
    useEffect(function () {
        var video = videoRef.current;
        if (video) {
            if (activeForm === 'login' && isVideoPlayable) {
                var playPromise = video.play();
                if (playPromise !== undefined) {
                    /* eslint-disable */
                    playPromise.then(function (_) {
                    })
                        .catch(function (error) {
                    });
                }
            }
            else {
                video.pause();
            }
        }
    }, [activeForm === 'login']);
    var handleMouseEnter = function () {
        setVideoControlsVisible(true);
    };
    var handleMouseLeave = function () {
        var _a;
        if (!((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.paused)) {
            setVideoControlsVisible(false);
        }
    };
    useEffect(function () {
        var handleResize = function () {
            setIsVideoPlayable(window.innerWidth >= 768);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var handleFormChangeAnimate = function (activeForm) {
        if (animationClass === 'fadeIn') {
            setAnimationClass('fadeOut');
            var animationDuration = 100;
            setTimeout(function () {
                setActiveForm(activeForm);
                setAnimationClass('fadeIn');
            }, animationDuration);
        }
    };
    var HeaderStyles = {
        left: '20px',
        position: 'absolute',
        right: '20px',
        top: '20px',
        zIndex: 5,
    };
    var height100vhContainerStyles = {
        height: '100%',
        overflow: activeForm !== 'registration' ? 'hidden' : '',
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: 1,
    };
    return (_jsx(FormContext.Provider, __assign({ value: { dispatch: dispatch, state: state } }, { children: _jsxs(_Fragment, { children: [_jsx("video", __assign({ ref: videoRef, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, autoPlay: false, controls: !isVideoControlsVisible, playsInline: true, loop: true, muted: true, className: "bgVideo" }, { children: _jsx("source", { src: videoBg, type: 'video/mp4' }) })), _jsxs(SpaceBetweenContainer, __assign({ style: HeaderStyles }, { children: [_jsx(LangSwitcher, {}), _jsxs(RightAlignedComponent, { children: [_jsx("a", __assign({ href: 'https://play.google.com/store/apps/details?id=tools.gad24.app&hl=de_CH', target: "_blank" }, { children: _jsx("img", { alt: 'google play', src: Icons.googlePlay, className: 'appButton' }) })), _jsx("a", __assign({ href: 'https://apps.apple.com/ch/app/gad24-app/id1510948466', target: "_blank" }, { children: _jsx("img", { alt: 'app store', src: Icons.appStore, className: 'appButton' }) }))] })] })), _jsx("div", __assign({ style: height100vhContainerStyles }, { children: _jsx(FormWrapper, { activeForm: activeForm, setActiveForm: setActiveForm, handleFormChange: handleFormChange, handleFormChangeAnimate: handleFormChangeAnimate, animationClass: animationClass }) }))] }) })));
}
